import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

// import root from './modules/root' // 根信息
import user from './modules/user' // 用户信息
import website from './modules/website' // 网站管理
import route from './modules/route' // 路由管理
import paymentRecord from './modules/paymentRecord' // 路由管理
import logisticsManage from './modules/logisticsManage' // 物流管理
import riskTranscation from './modules/riskTranscation'
import permission from './modules/permission'
import ppAuth from './modules/ppAuth' // 平台授权
import personCertification from './modules/personCertification' // 法人、股东、受益人变更

const debug = process.env.NODE_ENV !== 'production'

const store = new Vuex.Store({
	/**
   * 此处注册的modules默认为第一级模块，无法被动态卸载
   */
  modules: {
    user,
    website,
    route,
    paymentRecord,
    // dataReport,
    logisticsManage,
    riskTranscation,
    permission,
    ppAuth,
    personCertification
  },
  strict: debug
})
export default store
